import { isMoney, getType, getValue } from '../../../helpers/shop'

import vipPoints from '../../../assets/images/vip-points.svg'

const Product = ({ product, openModal }) => {
  const { name, image, styles, fill } = getType(product)

  return (
    <div className="bg-[#433535]">
      <div className="pt-[1px] px-[1px] bg-gradient-to-b from-[rgba(87,210,84,0.52)] to-[rgba(0,220,0,0)]">
        <div className="flex flex-col h-[55px] items-center justify-center bg-[#433535]">
          <div className="flex space-x-[7px] items-center justify-center">
            <svg
              width="11"
              height="12"
              className="shrink-0"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.373 4.97461V6.67383H0.626953V4.97461H10.373ZM6.4082 0.824219V11.1758H4.60156V0.824219H6.4082Z"
                fill={fill ? fill : '#57D254'}
              />
            </svg>
            {image && (
              <i
                className={`shrink-0 ${styles} bg-no-repeat bg-cover`}
                style={{ backgroundImage: `url(${image})` }}
              />
            )}
            <p className="text-[16px] text-white">{getValue(product.quantity)}</p>
          </div>
          <div className="flex mt-[2px] space-x-[5px] items-center justify-center">
            <i
              className="shrink-0 w-[16px] h-[14px] bg-cover"
              style={{ backgroundImage: `url(${vipPoints})` }}
            />
            <p className="leading-[14px] text-[10px] text-white">+{getValue(product.vipPoints)} VIP EXP</p>
          </div>
        </div>
      </div>
      <button
        type="button"
        className={`block w-full p-[18px] leading-[18px] text-[16px] text-white ${isMoney(name) ? 'bg-[#57d254]' : 'bg-[#ffca42]'}`}
        onClick={() => openModal(product)}
      >
        {getValue(product.price)}
        <span className="text-[10px]">₽</span>
      </button>
    </div>
  )
}

export default Product
